/** Shared CMS/route slug segments used by web, business, and Sanity. */
export const surpriseBagSeoKeyword = 'find';

export const partnersPathSegment = 'partners';

export const partnersCityPathSegment = 'partners-city';

export const authorsPathSegment = 'author';

/** Hub segment for Marketplace Pages children (`/{locale}/marketplace/{slug}`). */
export const marketplacePathSegment = 'marketplace';

/** Hub segment for Parcels Pages children (`/{locale}/parcels/{slug}`). */
export const parcelsPathSegment = 'parcels';

/** Hub segment for Platform Pages children (`/{locale}/platform/{slug}`). */
export const platformPathSegment = 'platform';

/**
 * Hub segment for Date labelling Pages children.
 * Desk title is "Date labelling"; public URL uses `look-smell-taste`
 * (`/{locale}/look-smell-taste/{slug}`).
 */
export const dateLabellingPathSegment = 'look-smell-taste';

/** Hub segment for Donations children (`/{locale}/donations/{slug}`). */
export const donationsPathSegment = 'donations';

/** Hub segment for business Initiatives children (`/{locale}/initiatives/{slug}`). */
export const initiativesPathSegment = 'initiatives';
